import { Link } from "@tanstack/react-router";
import { Phone, MessageCircle, MapPin, ChevronRight } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { COMPANY } from "@/lib/company";

export function ProvincePageShell({
  eyebrow,
  title,
  subtitle,
  breadcrumb,
  children,
}: {
  eyebrow: string;
  title: string;
  subtitle: string;
  breadcrumb: { label: string; to?: string }[];
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <section className="relative isolate overflow-hidden text-primary-foreground" style={{ background: "var(--gradient-hero)" }}>
        <div aria-hidden className="absolute inset-0 -z-10 opacity-[0.06]" style={{ backgroundImage: "var(--grid-pattern)", backgroundSize: "40px 40px" }} />
        <div className="mx-auto max-w-7xl px-4 py-14 md:py-20">
          <nav className="flex flex-wrap items-center gap-1.5 text-xs text-primary-foreground/90">
            {breadcrumb.map((b, i) => (
              <span key={i} className="flex items-center gap-1.5">
                {b.to ? <Link to={b.to} className="hover:text-gold">{b.label}</Link> : <span className="text-gold">{b.label}</span>}
                {i < breadcrumb.length - 1 && <ChevronRight className="h-3 w-3" />}
              </span>
            ))}
          </nav>
          <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-gold">
            <MapPin className="h-3.5 w-3.5" /> {eyebrow}
          </div>
          <h1 className="mt-4 max-w-4xl text-3xl font-black leading-tight md:text-5xl">{title}</h1>
          <p className="mt-4 max-w-3xl text-base text-primary-foreground/95 md:text-lg">{subtitle}</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={`tel:${COMPANY.phoneIntl}`} className="inline-flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-bold text-gold-foreground shadow-[var(--shadow-gold-glow)]" style={{ background: "var(--gradient-gold)" }}>
              <Phone className="h-4 w-4" /> {COMPANY.phone}
            </a>
            <a href={`https://line.me/R/ti/p/${COMPANY.lineId}`} target="_blank" rel="noopener" className="inline-flex items-center gap-2 rounded-xl border-2 border-gold px-5 py-3 text-sm font-bold text-gold">
              <MessageCircle className="h-4 w-4" /> LINE {COMPANY.lineId}
            </a>
          </div>
        </div>
      </section>
      <main id="main-content">{children}</main>
      <SiteFooter />
    </div>
  );
}